import ApiService from "@/services/api.service";

export async function getAllRoles(){
    let response = await ApiService.get("roles/get/all");
    return response.data;
}